import React from 'react';
import ReactDOM from 'react-dom';
import Navbar from './components/NavBar';

const headerNode = document.getElementById('cccisd-header');
if (headerNode) {
    ReactDOM.render(<Navbar />, headerNode);
}
